import { render, staticRenderFns } from "./MsgIdle.vue?vue&type=template&id=b42cea58"
import script from "./MsgIdle.vue?vue&type=script&lang=js"
export * from "./MsgIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports